@if (isLogged()) {
<pf-aside />
}
<ion-router-outlet id="main"></ion-router-outlet>
<quang-loader>
    <div loader>
        <div class="spinner-border" role="status">
        </div>
    </div>
</quang-loader>
